import { AfterViewInit, Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { CommonService } from 'src/app-core/services/common.service';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { MaterialCategoryEnum, OrderTypeEnum } from '../app-common-enum';
import { CommonDataModel } from '../common-data-model';
import { ModifiersStructuresComponent } from '../modifiers-structures/modifiers-structures.component';
import { OrdersConatinerFutureUseFormComponent } from '../orders-conatiner-future-use-form/orders-conatiner-future-use-form.component';
import { OrdersFloaterSpacingComponent } from '../orders-floater-spacing/orders-floater-spacing.component';
import { OrdersMaterialGridComponent } from '../orders-material-grid/orders-material-grid.component';
import { CommonConstants } from 'src/app-core/constants/common-constants';

@Component({
    selector: 'app-orders-modifiers-structures',
    templateUrl: './orders-modifiers-structures.component.html',
    styleUrls: ['./orders-modifiers-structures.component.scss']
})
export class OrdersModifiersStructuresComponent extends AppComponentBase implements OnInit, AfterViewInit {


    @Input() set collapsingValue(collapsingValue: any) {
        if (collapsingValue) {
            this.materailsGridsCollapsing = collapsingValue;
        }
    }
    @Input() orderTypeId: number;
    @Input() isContainerSummryOpen: any;
    @Input() set containerIdParam(containerId: number) {
        if (containerId) {
            this.containerId = containerId;
        }
    }
    @Input() set containerData(containerData: any) {
        this.containerDetails = containerData;
        this.setContainerDetails();
        this.getContainerIdsParams();
        this.loadMaterials();
    }
    @Input() set containerSummaryParams(data: any) {
        this.containerSummary = data;
    }
    @Input() readOnly: boolean;
    @Output() emitGetContainerToggle: EventEmitter<any> = new EventEmitter<any>();
    @Output() emitChangeContainerSummary: EventEmitter<any> = new EventEmitter<any>();
    @Output() getContainerDetails: EventEmitter<any> = new EventEmitter<any>();
    @ViewChild('BCMSDComponent', { static: false }) BCMSDComponent:
        ModifiersStructuresComponent;
    @ViewChild('OrderContainerMaterialGridComponent', { static: false }) OrderContainerMaterialGridComponent: OrdersMaterialGridComponent;
    @ViewChild('OrderContainerFloatersGridComponent', { static: false }) OrderContainerFloatersGridComponent: OrdersMaterialGridComponent;
    @ViewChild('OrderContainerPalletGridComponent', { static: false }) OrderContainerPalletGridComponent: OrdersMaterialGridComponent;
    @ViewChild('OrderContainerBottomDeckGridComponent', { static: false }) OrderContainerBottomDeckGridComponent: OrdersMaterialGridComponent;
    @ViewChild('OrderContainerGussetsGridComponent', { static: false }) OrderContainerGussetsGridComponent: OrdersMaterialGridComponent;
    @ViewChild('OrderContainerFPRubStripGridComponent', { static: false }) OrderContainerFPRubStripGridComponent: OrdersMaterialGridComponent;
    @ViewChild('floaterSpacing', { static: false }) floaterSpacing: OrdersFloaterSpacingComponent;

    commonDataModel = new CommonDataModel();
    materialCategoryEnum: typeof MaterialCategoryEnum = MaterialCategoryEnum;
    modifiersStructuresModel = _.cloneDeep(this.commonDataModel.boxContainerFormModel);
    futureContainerModel = _.cloneDeep(this.commonDataModel.futureUseContainer);
    orderTypeEnum: typeof OrderTypeEnum = OrderTypeEnum;
    updateModifiers = _.cloneDeep(this.commonDataModel.updateModifiersModel);
    containerReset = _.cloneDeep(this.commonDataModel.containerResetModel);

    containerIds: any = [];
    containerIdsString: any;
    floaterIdsString: any;
    palletIdsString: any;
    bottomDeckIdsString: any;
    gussetsIdsString: any;
    rubStripsIdsString: any;
    editContainerId: any = null;
    containerId: number;
    containerDetails: any;
    twoLineItemString: string;
    allLineItemString: string;
    containerModifierCopy: any;
    containerSummary: any;
    initialLoad = true;
    enableSavebutton = false;
    isFormLoading = false;
    materailsGridsCollapsing: any;
    isMaterialLocked = false;
    isTotalsLocked = false;
    isPartiallyLocked = false;
    orderId: any;
    isJob = true;
    constructor(
        injector: Injector,
        private toastr: ToastrService,
        private commonService: CommonService,
        private dialog: MatDialog,
        private activatedRoute: ActivatedRoute
    ) {
        super(injector);
        if (this.activatedRoute.snapshot.queryParams.jobId) {
            this.orderId = this.activatedRoute.snapshot.queryParams.jobId;
            this.isJob = true;
        } else {
            this.orderId = this.activatedRoute.snapshot.queryParams.quoteId;
            this.isJob = false;
        }
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.containerDetails) {
                this.setContainerDetails();
                this.getContainerIdsParams();
            }
        }, 0);
    }

    collapseEmit(event: any) {
        if (this.OrderContainerMaterialGridComponent) {
            this.materailsGridsCollapsing.materials = this.OrderContainerMaterialGridComponent.isExpanded;
        }
        if (this.OrderContainerFloatersGridComponent) {
            this.materailsGridsCollapsing.materials = this.OrderContainerFloatersGridComponent.isExpanded;
        }
        if (this.floaterSpacing) {
            this.materailsGridsCollapsing.materials = this.floaterSpacing.isExpanded;
        }
        if (this.OrderContainerPalletGridComponent) {
            this.materailsGridsCollapsing.materials = this.OrderContainerPalletGridComponent.isExpanded;
        }
        if (this.OrderContainerBottomDeckGridComponent) {
            this.materailsGridsCollapsing.materials = this.OrderContainerBottomDeckGridComponent.isExpanded;
        }
        if (this.OrderContainerGussetsGridComponent) {
            this.materailsGridsCollapsing.materials = this.OrderContainerGussetsGridComponent.isExpanded;
        }
        if (this.OrderContainerFPRubStripGridComponent) {
            this.materailsGridsCollapsing.materials = this.OrderContainerFPRubStripGridComponent.isExpanded;
        }
    }

    resetResources() {
        this.modifiersStructuresModel = _.cloneDeep(this.commonDataModel.boxContainerFormModel);
        this.futureContainerModel = _.cloneDeep(this.commonDataModel.futureUseContainer);
        this.updateModifiers = _.cloneDeep(this.commonDataModel.updateModifiersModel);
        this.containerIds = [];
        this.containerIdsString = null;
        this.floaterIdsString = null;
        this.palletIdsString = null;
        this.bottomDeckIdsString = null;
        this.gussetsIdsString = null;
        this.rubStripsIdsString = null;
        this.editContainerId = null;
        this.twoLineItemString = null;
        this.allLineItemString = null;
        this.containerModifierCopy = null;
        this.initialLoad = true;
        this.enableSavebutton = false;
        this.isFormLoading = false;
        this.resetForm();
    }

    resetForm() {
        this.OrderContainerMaterialGridComponent ? this.OrderContainerMaterialGridComponent.materialForm.form.markAsPristine() : null;
        this.OrderContainerFloatersGridComponent ? this.OrderContainerFloatersGridComponent.materialForm.form.markAsPristine() : null;
        this.OrderContainerPalletGridComponent ? this.OrderContainerPalletGridComponent.materialForm.form.markAsPristine() : null;
        this.OrderContainerBottomDeckGridComponent ? this.OrderContainerBottomDeckGridComponent.materialForm.form.markAsPristine() : null;
        this.OrderContainerGussetsGridComponent ? this.OrderContainerGussetsGridComponent.materialForm.form.markAsPristine() : null;
        this.OrderContainerFPRubStripGridComponent ? this.OrderContainerFPRubStripGridComponent.materialForm.form.markAsPristine() : null;
        this.floaterSpacing ? this.floaterSpacing.floaterSpacingForm.form.markAsPristine() : null;
        this.BCMSDComponent ? this.BCMSDComponent.modifiersForm.form.markAsPristine() : null;
        this.enableSavebutton = false;
    }

    loadMaterials() {
        if (this.containerDetails) {
            this.createHeaderString();
            this.setContainerDetails();
        }
    }

    createHeaderString() {
        this.twoLineItemString = '';
        this.allLineItemString = '';
        this.containerDetails.lineItems.map((item, index) => {
            this.allLineItemString += `${(item.categoryName) ? item.categoryName : ''},${(item.itemName) ? item.itemName : ''}
      ${item.length}x${item.width}x${item.height}${(this.containerDetails.lineItems.length - 1) !== index ? ',' : ' '}`;
            if (index < 2) {
                this.twoLineItemString += `${(item.categoryName) ? item.categoryName : ''},${(item.itemName) ? item.itemName : ''}
        ${item.length}x${item.width}x${item.height}${(index === 0 && this.containerDetails.lineItems.length > 1) ? ', ' :
                        (index === 1 && this.containerDetails.lineItems.length > 2) ? ', ' : ''
                    }`;
            }
        });
    }

    setContainerDetails() {
        if (this.containerDetails && this.containerDetails.containerModifier) {
            if (this.BCMSDComponent) {
                this.containerModifierCopy = _.cloneDeep(this.containerDetails.containerModifier);
                this.BCMSDComponent.dropdownsObject = _.cloneDeep(this.containerDetails.containerModifier);
            }
            this.isMaterialLocked = this.containerDetails.isMaterialLocked;
            this.isPartiallyLocked = this.containerDetails.isPartialLocked;
            this.isTotalsLocked = this.containerDetails.isTotalLocked;
            this.containerIdsString = {
                itemContainerId: this.containerDetails.itemContainerId,
                baseContainerId: this.containerDetails.baseContainerId,
                parentContainerId: this.containerDetails.baseContainerId,
                templateContainerId: this.containerDetails.templateContainerId,
                selectedModifierId: this.containerDetails.selectedModifierId,
                initialLoad: this.initialLoad,
                isModiAndStructure: false
            };
        }
    }

    getContainerIdsParams() {
        if (this.BCMSDComponent) {
            if (this.BCMSDComponent.dropdownsObject.floaterId) {
                const floaterIds = {
                    itemContainerId: this.containerDetails.itemContainerId,
                    baseContainerId: this.BCMSDComponent.dropdownsObject.floaterId,
                    parentContainerId: this.BCMSDComponent.dropdownsObject.floaterParentContainerId,
                    initialLoad: this.initialLoad,
                    isModiAndStructure: true,
                    isInitialValChanged: true,
                    templateContainerId: this.BCMSDComponent.dropdownsObject.floaterTemplateContainerId,
                    selectedModifierId: this.BCMSDComponent.dropdownsObject.floaterId
                };
                if (this.containerModifierCopy.floaterId !== this.BCMSDComponent.dropdownsObject.floaterId) {
                    floaterIds.isInitialValChanged = true;
                } else {
                    floaterIds.isInitialValChanged = false;
                }
                this.floaterIdsString = floaterIds;
            }
            if (this.BCMSDComponent.dropdownsObject.palletId) {
                const palletIds = {
                    itemContainerId: this.containerDetails.itemContainerId,
                    baseContainerId: this.BCMSDComponent.dropdownsObject.palletId,
                    parentContainerId: this.BCMSDComponent.dropdownsObject.palletParentContainerId,
                    initialLoad: this.initialLoad,
                    isModiAndStructure: true,
                    isInitialValChanged: true,
                    templateContainerId: this.BCMSDComponent.dropdownsObject.palletTemplateContainerId,
                    selectedModifierId: this.BCMSDComponent.dropdownsObject.palletId
                };
                if (this.containerModifierCopy.palletId !== this.BCMSDComponent.dropdownsObject.palletId) {
                    palletIds.isInitialValChanged = true;
                } else {
                    palletIds.isInitialValChanged = false;
                }
                this.palletIdsString = palletIds;
            }
            if (this.BCMSDComponent.dropdownsObject.bottomDeckBoardId) {
                const bottomDeckIds = {
                    itemContainerId: this.containerDetails.itemContainerId,
                    baseContainerId: this.BCMSDComponent.dropdownsObject.bottomDeckBoardId,
                    parentContainerId: this.BCMSDComponent.dropdownsObject.bottomDeckBoardParentContainerId,
                    initialLoad: this.initialLoad,
                    isModiAndStructure: true,
                    isInitialValChanged: true,
                    templateContainerId: this.BCMSDComponent.dropdownsObject.bottomDeckBoardTemplateContainerId,
                    selectedModifierId: this.BCMSDComponent.dropdownsObject.bottomDeckBoardId
                };
                if (this.containerModifierCopy.bottomDeckBoardId !== this.BCMSDComponent.dropdownsObject.bottomDeckBoardId) {
                    bottomDeckIds.isInitialValChanged = true;
                } else {
                    bottomDeckIds.isInitialValChanged = false;
                }
                this.bottomDeckIdsString = bottomDeckIds;
            }
            if (this.BCMSDComponent.dropdownsObject.gussetsId) {
                const gussetsDeckIds = {
                    itemContainerId: this.containerDetails.itemContainerId,
                    baseContainerId: this.BCMSDComponent.dropdownsObject.gussetsId,
                    parentContainerId: this.BCMSDComponent.dropdownsObject.gussetsParentContainerId,
                    initialLoad: this.initialLoad,
                    isModiAndStructure: true,
                    isChanged: true,
                    isInitialValChanged: true,
                    templateContainerId: this.BCMSDComponent.dropdownsObject.gussetsTemplateContainerId,
                    selectedModifierId: this.BCMSDComponent.dropdownsObject.gussetsId
                };
                if (this.containerModifierCopy.gussetsId !== this.BCMSDComponent.dropdownsObject.gussetsId) {
                    gussetsDeckIds.isInitialValChanged = true;
                } else {
                    gussetsDeckIds.isInitialValChanged = false;
                }
                this.gussetsIdsString = gussetsDeckIds;
            }
            if (this.BCMSDComponent.dropdownsObject.fullPerpendicularRubStripsId) {
                const rubStripsDeckIds = {
                    itemContainerId: this.containerDetails.itemContainerId,
                    baseContainerId: this.BCMSDComponent.dropdownsObject.fullPerpendicularRubStripsId,
                    parentContainerId: this.BCMSDComponent.dropdownsObject.fullPerpendicularRubStripsParentContainerId,
                    initialLoad: this.initialLoad,
                    isModiAndStructure: true,
                    isChanged: true,
                    isInitialValChanged: true,
                    templateContainerId: this.BCMSDComponent.dropdownsObject.fullPerpendicularRubStripsTemplateContainerId,
                    selectedModifierId: this.BCMSDComponent.dropdownsObject.fullPerpendicularRubStripsId
                };
                if (this.containerModifierCopy.fullPerpendicularRubStripsId !== this.BCMSDComponent.dropdownsObject.fullPerpendicularRubStripsId) {
                    rubStripsDeckIds.isInitialValChanged = true;
                } else {
                    rubStripsDeckIds.isInitialValChanged = false;
                }
                this.rubStripsIdsString = rubStripsDeckIds;
            }
            this.initialLoad = false;
        }
    }

    loadContainerIds(data: any): void {
        this.getContainerIdsParams();
        this.onEnableSaveButton();
    }

    onFutureUse() {
        this.createFutureContainer();
        this.dialog.open(OrdersConatinerFutureUseFormComponent, {
            panelClass: 'small_center_layout',
            hasBackdrop: false,
            data: { containerDetails: this.futureContainerModel },
        }).afterClosed().subscribe((response: any) => {
            if (response && response.confirmResult === true) {
                if (response.selectedContainer === 0) {
                }
            }
        });
    }

    onToggleConatinerSummary() {
        this.emitGetContainerToggle.emit();
    }

    onResetAll() {
        this.commonService.getConfirmationPopup(`Are you sure?
    Do you want to Reset?`).then(result => {
            if (result) {
                this.containerReset.containerId = this.containerDetails.containerId;
                this.containerReset.itemContainerId = this.containerDetails.itemContainerId;
                this.containerReset.quantity = this.containerDetails.quantity;
                this.containerReset.orderId = this.containerDetails.orderId;
                this.commonService.containerReset(this.containerReset)
                    .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                        this.isFormLoading = false;
                        if (response.isSuccess) {
                            this.toastr.success(`Container reset Successfully`);
                            this.resetResources();
                            this.getContainerDetails.emit();
                        }
                    });
            }
        });
    }

    onCancelAll() {
        this.emitChangeContainerSummary.emit();
        this.BCMSDComponent.dropdownsObject = _.cloneDeep(this.containerDetails.containerModifier);
        if (this.OrderContainerMaterialGridComponent) {
            this.OrderContainerMaterialGridComponent.onReset();
        }
        if (this.OrderContainerFloatersGridComponent) {
            this.OrderContainerFloatersGridComponent.onReset();
        }
        if (this.OrderContainerPalletGridComponent) {
            this.OrderContainerPalletGridComponent.onReset();
        }
        if (this.OrderContainerBottomDeckGridComponent) {
            this.OrderContainerBottomDeckGridComponent.onReset();
        }
        if (this.OrderContainerGussetsGridComponent) {
            this.OrderContainerGussetsGridComponent.onReset();
        }
        if (this.OrderContainerFPRubStripGridComponent) {
            this.OrderContainerFPRubStripGridComponent.onReset();
        }
    }

    onEnableSaveButton() {
        if ((this.BCMSDComponent && this.BCMSDComponent.modifiersForm.dirty) ||
            (this.floaterSpacing && this.floaterSpacing.floaterSpacingForm.dirty) ||
            (this.OrderContainerMaterialGridComponent && this.OrderContainerMaterialGridComponent.materialForm.dirty) ||
            (this.OrderContainerFloatersGridComponent && this.OrderContainerFloatersGridComponent.materialForm.dirty) ||
            (this.OrderContainerPalletGridComponent && this.OrderContainerPalletGridComponent.materialForm.dirty) ||
            (this.OrderContainerBottomDeckGridComponent && this.OrderContainerBottomDeckGridComponent.materialForm.dirty) ||
            (this.OrderContainerGussetsGridComponent && this.OrderContainerGussetsGridComponent.materialForm.dirty) ||
            (this.OrderContainerFPRubStripGridComponent && this.OrderContainerFPRubStripGridComponent.materialForm.dirty)) {
            if (((this.OrderContainerMaterialGridComponent && this.OrderContainerMaterialGridComponent.materialForm.form.valid) || (!this.OrderContainerMaterialGridComponent)) &&
                ((this.OrderContainerFloatersGridComponent && this.OrderContainerFloatersGridComponent.materialForm.form.valid) || !this.OrderContainerFloatersGridComponent) &&
                ((this.OrderContainerPalletGridComponent && this.OrderContainerPalletGridComponent.materialForm.form.valid) || !this.OrderContainerPalletGridComponent) &&
                ((this.OrderContainerBottomDeckGridComponent && this.OrderContainerBottomDeckGridComponent.materialForm.form.valid) || !this.OrderContainerBottomDeckGridComponent) &&
                ((this.OrderContainerGussetsGridComponent && this.OrderContainerGussetsGridComponent.materialForm.form.valid) || !this.OrderContainerGussetsGridComponent) &&
                ((this.OrderContainerFPRubStripGridComponent && this.OrderContainerFPRubStripGridComponent.materialForm.form.valid) || !this.OrderContainerFPRubStripGridComponent)
            ) {
                this.enableSavebutton = true;
            } else {
                this.enableSavebutton = false;
            }

        }
    }


    UpdateModifiers() {
        this.commonService.objectMapping(this.updateModifiers, this.containerDetails);
        this.commonService.objectMapping(this.updateModifiers, this.containerSummary);
        if (this.OrderContainerFloatersGridComponent && this.OrderContainerFloatersGridComponent.gridItems.length > 0) {
            this.updateModifiers.floaterSummary.materials = this.OrderContainerFloatersGridComponent.getMaterials();
        } else {
            this.updateModifiers.floaterSummary = null;
        }
        if (this.OrderContainerPalletGridComponent && this.OrderContainerPalletGridComponent.gridItems.length > 0) {
            this.updateModifiers.palletSummary.materials = this.OrderContainerPalletGridComponent.getMaterials();
        } else {
            this.updateModifiers.palletSummary = null;
        }
        if (this.OrderContainerBottomDeckGridComponent && this.OrderContainerBottomDeckGridComponent.gridItems.length > 0) {
            this.updateModifiers.bottomDeckBoardSummary.materials = this.OrderContainerBottomDeckGridComponent.getMaterials();
        } else {
            this.updateModifiers.bottomDeckBoardSummary = null;
        }
        if (this.OrderContainerGussetsGridComponent && this.OrderContainerGussetsGridComponent.gridItems.length > 0) {
            this.updateModifiers.gussetsSummary.materials = this.OrderContainerGussetsGridComponent.getMaterials();
        } else {
            this.updateModifiers.gussetsSummary = null;
        }
        if (this.OrderContainerFPRubStripGridComponent && this.OrderContainerFPRubStripGridComponent.gridItems.length > 0) {
            this.updateModifiers.fullPerpendicularRubStripsSummary.materials = this.OrderContainerFPRubStripGridComponent.getMaterials();
        } else {
            this.updateModifiers.fullPerpendicularRubStripsSummary = null;
        }

        const orderMaterials = this.OrderContainerMaterialGridComponent.getMaterials();
        if (orderMaterials) {
            this.updateModifiers.orderMaterials = orderMaterials;
        }

        this.updateModifiers.containerDetails = {
            containerId: this.containerDetails.containerId,
            displayId: this.containerDetails.displayId,
            containerName: this.containerDetails.containerName,
            baseContainerId: this.containerDetails.baseContainerId,
            minimumMinutes: this.containerDetails.minimumMinutes,
            customFixedLabour: this.containerDetails.customFixedLabour,
            defaultLabourMethod: this.containerDetails.defaultLabourMethodId,
            isStockContainer: this.containerDetails.isStockContainer,
            isActive: this.containerDetails.isActive,
            containerDetails: this.BCMSDComponent.dropdownsObject
        };
        this.updateModifiers.containerQuantity = this.updateModifiers.quantity;
        this.isFormLoading = true;
        if (this.floaterSpacing && this.floaterSpacing.gridItems && this.floaterSpacing.gridItems.data.length > 0) {
            this.updateModifiers.floaterSpacing = {};
            this.updateModifiers.floaterSpacing.floaterSpacingId = this.floaterSpacing.gridItems.data[0].floaterSpacingId ? this.floaterSpacing.gridItems.data[0].floaterSpacingId : null;
            this.updateModifiers.floaterSpacing.itemContainerId = this.updateModifiers.itemContainerId;
            this.updateModifiers.floaterSpacing.orderId = this.updateModifiers.orderId;
            this.updateModifiers.floaterSpacing.endOne = this.floaterSpacing.gridItems.data[0].endOne;
            this.updateModifiers.floaterSpacing.endTwo = this.floaterSpacing.gridItems.data[0].endTwo;
            this.updateModifiers.floaterSpacing.sideOne = this.floaterSpacing.gridItems.data[0].sideOne;
            this.updateModifiers.floaterSpacing.sideTwo = this.floaterSpacing.gridItems.data[0].sideTwo;
            this.updateModifiers.floaterSpacing.top = this.floaterSpacing.gridItems.data[0].top;
            this.updateModifiers.floaterSpacing.bottom = this.floaterSpacing.gridItems.data[0].bottom;
        }
        this.commonService.updateOrderModifier(this.updateModifiers)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                if (response.isSuccess) {
                    if ((this.isJob)) {
                        this.toastr.success(CommonConstants.updateOrderModifierNotificationConstants.updateJobOrderModifierNotification);
                    } else if ((!this.isJob)) {
                        this.toastr.success(CommonConstants.updateOrderModifierNotificationConstants.updateQuoteOrderModifierNotification);
                    } else {
                        this.toastr.success(CommonConstants.updateOrderModifierNotificationConstants.updateQuoteJobOrderModifierNotification);
                    }
                    this.resetResources();
                    this.getContainerDetails.emit();
                }
            });
    }


    async onUpdateAllChanges() {
        if (this.isMaterialLocked || this.isTotalsLocked) {
            await this.commonService.getConfirmationPopup(`Totals are locked!?
      Do you want to Unlock and recalculate?`, null, null, true).then(result => {
                if (result) {
                    this.updateModifiers.isLockedChanged = true;
                    this.UpdateModifiers();
                } else {
                    this.UpdateModifiers();
                }
            });
        } else {
            this.UpdateModifiers();
        }
    }

    createFutureContainer() {
        this.futureContainerModel.containerId = this.containerDetails.containerId;
        this.futureContainerModel.containerDetails = this.BCMSDComponent.dropdownsObject;
        if (this.OrderContainerMaterialGridComponent && this.OrderContainerMaterialGridComponent.gridItems.length > 0) {
            this.futureContainerModel.containerMaterials = this.OrderContainerMaterialGridComponent.gridItems;
        }
        if (this.OrderContainerPalletGridComponent && this.OrderContainerPalletGridComponent.gridItems.length > 0) {
            this.futureContainerModel.palletMaterials = this.OrderContainerPalletGridComponent.gridItems;
        }
        if (this.OrderContainerFloatersGridComponent && this.OrderContainerFloatersGridComponent.gridItems.length > 0) {
            this.futureContainerModel.floaterMaterials = this.OrderContainerFloatersGridComponent.gridItems;
        }
        if (this.OrderContainerBottomDeckGridComponent && this.OrderContainerBottomDeckGridComponent.gridItems.length > 0) {
            this.futureContainerModel.bdbMaterials = this.OrderContainerBottomDeckGridComponent.gridItems;
        }
        if (this.OrderContainerGussetsGridComponent && this.OrderContainerGussetsGridComponent.gridItems.length > 0) {
            this.futureContainerModel.gussetMaterials = this.OrderContainerGussetsGridComponent.gridItems;
        }
        if (this.OrderContainerFPRubStripGridComponent && this.OrderContainerFPRubStripGridComponent.gridItems.length > 0) {
            this.futureContainerModel.fprsMaterials = this.OrderContainerFPRubStripGridComponent.gridItems;
        }
    }

    onModChange(data: any) {
        if (data === this.materialCategoryEnum.lumber) {
            if (this.BCMSDComponent.dropdownsObject.cleatsId) {
                this.onEnableSaveButton();
                this.OrderContainerMaterialGridComponent.setCleatmaterials(this.BCMSDComponent.dropdownsObject.cleatsId);
            }
        }
        if (data === this.materialCategoryEnum.plywood) {
            if (this.BCMSDComponent.dropdownsObject.plywoodId) {
                this.onEnableSaveButton();
                this.OrderContainerMaterialGridComponent.setplywoodmaterials(this.BCMSDComponent.dropdownsObject.plywoodId);
            }
        }
    }

    onEmitChildBusy(event: any) {
        this.isFormLoading = event;
    }

    onAdminRecalculation() {
        const requestData = {
            orderId: this.orderId
        };
        this.isFormLoading = true;
        this.commonService.orderAdminRecalc(requestData)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                if (response.isSuccess) {
                    this.isFormLoading = false;
                    this.toastr.success(response.errors || `${this.isJob ? 'Job' : `Quote`} Updated Successfully`);
                    this.resetResources();
                    this.getContainerDetails.emit();
                }
            });
    }

    onContainerCutSheet(data: any) {
        const requestData = {
            emailDetails: '',
            isSendEmail: false,
            isShowImage: false,
            isview: true,
            orderId: this.orderId,
            itemContainerId: data.itemContainerId
        };
        this.isFormLoading = true;
        this.commonService.cutSheetViewDocument(requestData)
            .pipe(finalize(() => (this.isFormLoading = false))).subscribe(response => {
                this.isFormLoading = false;
                const data: any = response;
                this.commonService.viewBolbFile(data.body as any, { type: data.body.type }, ``);
            });
    }

}
